import { Settings, Search, Zap, LogOut } from 'lucide-react';
import { SpaceSwitcher } from './SpaceSwitcher';
import { ViewSelector } from './ViewSelector';
import { DateNav, WeekNav } from './DateNav';
import { useAppStore } from '../../store';
import { supabase } from '../../lib/supabase';

export function Header({ onOpenSettings, onOpenPalette }: { onOpenSettings?: () => void; onOpenPalette?: () => void }) {
  const panelOpen = useAppStore((s) => !!s.selectedTaskId);
  const headerContext = useAppStore((s) => s.headerContext);
  const currentView = useAppStore((s) => s.currentView);
  const showDayNav = currentView === 'track' || currentView === 'calendar';
  const showWeekNav = currentView === 'planner' || currentView === 'summary';

  return (
    <header className={`flex items-center h-12 px-5 bg-bg-app border-b border-border-subtle transition-[margin] duration-200 ease-out ${panelOpen ? 'mr-96' : ''}`}>
      {/* Logo */}
      <div className="flex items-center gap-2.5 shrink-0">
        <div className="w-7 h-7 rounded-lg bg-brand flex items-center justify-center shadow-md shadow-brand/25 hover:shadow-lg hover:shadow-brand/40 transition-shadow">
          <Zap size={14} className="text-white" strokeWidth={2.5} />
        </div>
        <span className="text-body font-extrabold tracking-tighter text-text-primary">Stride</span>
      </div>

      {/* Separator */}
      <div className="w-px h-5 bg-border-subtle mx-3 shrink-0" />

      {/* View tabs */}
      <ViewSelector />

      {/* Flex spacer */}
      <div className="flex-1" />

      {/* Date navigation + context */}
      {showDayNav && <DateNav taskCount={headerContext?.count} contextLabel={headerContext?.label} />}
      {showWeekNav && <WeekNav />}

      {/* Utility icons */}
      <div className="flex items-center gap-1 ml-3 shrink-0">
        <button
          onClick={onOpenPalette}
          className="p-2 rounded-lg interactive-ghost text-text-muted hover:text-text-secondary hover:scale-110 transition-transform"
          title="Search (⌘K)"
          aria-label="Search"
        >
          <Search size={16} />
        </button>
        <SpaceSwitcher />
        {onOpenSettings && (
          <button
            onClick={onOpenSettings}
            className="p-2 rounded-lg interactive-ghost text-text-muted hover:text-text-secondary hover:scale-110 transition-transform"
            title="Settings"
            aria-label="Settings"
          >
            <Settings size={16} />
          </button>
        )}
        {supabase && (
          <button
            onClick={() => { void supabase?.auth.signOut(); }}
            className="p-2 rounded-lg interactive-ghost text-text-muted hover:text-text-secondary hover:scale-110 transition-transform"
            title="Sign out"
            aria-label="Sign out"
          >
            <LogOut size={16} />
          </button>
        )}
      </div>
    </header>
  );
}
